import Immutable, {Map, List} from 'immutable';

class InlineException extends waffle.base.BaseComponent {
  renderResolved() {
    const link = `/exceptions/${this.props.exception.get('uuid')}`;
    const resolvedBy = this.props.exception.getIn(['resolvedByUser', 'fullName']);

    return (
      <div className="alert alert-info inline-exception inline-exception-resolved">
        Resolved Exception: <b><a className="alert-link" href={link}>{this.props.exception.get('title')}</a></b> ({this.props.exception.get('exceptionState').humanize()})<br />
        Resolution: { this.props.exception.get('resolution', 'Resolved in admin') }: { this.props.exception.get('resolutionComment', 'No extra information')} at <b>{ this.props.exception.get('dateResolved') }</b><br />
        { resolvedBy ? "Resolved by: " + resolvedBy : null}{ resolvedBy ? <br /> : null}
        {this.props.exception.get('description')}
      </div>
    );
  }

  renderResolutions() {
    if (this.props.exception.get('resolutions', List()).count() > 0) {
      return (
        <div className="inline-exception-resolutions">
          {
            this.props.exception.get('resolutions', List()).map((resolution) => {
              return (
                <span key={resolution.get('identifier')}>
                  <waffle.buttons.ApiButton
                    className="btn btn-sm ladda-button btn-warning-alert"
                    label={resolution.get('name')}
                    api={`/api/exceptions/${this.props.exception.get('uuid')}/resolve?resolution=${resolution.get('identifier')}`}
                    onSuccess={(result) => {
                      this.props.exceptionResolved(this.props.exception)
                    }}
                  />
                  &nbsp;
                </span>
              );
            })
          }
        </div>
      );
    }
  }

  render() {
    if (this.props.exception.get('isResolved')) {
      return this.renderResolved();
    } else {
      const link = `/exceptions/${this.props.exception.get('uuid')}`;
      return (
        <div className="alert alert-warning inline-exception">
          Exception: <b><a className="alert-link" href={link}>{this.props.exception.get('title')}</a></b> ({this.props.exception.get('exceptionState').humanize()})<br />
          {this.props.exception.get('description')}

          {this.renderResolutions()}
        </div>
      );
    }
  }
}

class InlineExceptions extends waffle.base.BaseComponent {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() {
    this.fetchExceptions();
  }

  fetchExceptions() {
    $.ajax({
      url: `/api/exceptions/source/${this.props.uuid}`,
      dataType: 'json',
      type: 'GET'
    }).done((response) => {
      if (response.status == 200) {
        this.setState({
          exceptions: Immutable.fromJS(response.data.exceptions),
          errorMessage: null
        });
      } else {
        this.setState({
          errorMessage: response.message ? response.message : "Unknown error"
        });
      }
    }).fail((unused, textStatus) => {
      this.setState({
        errorMessage: textStatus
      });
    })
  }

  render() {
    if (this.state.exceptions) {
      return (
        <div className="inline-exceptions">
          {
            this.state.exceptions.map((exception) => {
              return (
                <InlineException
                  exception={exception} key={exception.get('uuid')}
                  exceptionResolved={(exception) => {
                    // Optimistically remove this exception
                    this.setState({
                      exceptions: this.state.exceptions.filter((e) => {
                        return e.get('uuid') != exception.get('uuid')
                      })
                    });

                    location.reload();
                  }}
                />
              )
            })
          }
        </div>
      );
    } else if (this.state.errorMessage) {
      return (
        <div className="alert alert-warning inline-exception">
          Unable to load list of exceptions: {this.state.errorMessage}
        </div>
      );
    }
    return <div></div>
  }
}

module.exports = {
  InlineExceptions
}
